export const calculatorTranslations = {
  fr: {
    title: "Calculateur Médical",
    subtitle: "Scores cliniques et formules médicales standardisées",
    search: "Rechercher un score, une formule...",
    filterBySpecialty: "Filtrer par spécialité",
    allSpecialties: "Toutes les spécialités",
    loading: "Chargement des calculateurs...",
    noCalculators: "Aucun calculateur disponible",
    noCalculatorsDesc: "Utilisez la recherche pour trouver un score médical",
    calculate: "Calculer",
    reset: "Réinitialiser",
    result: "Résultat",
    interpretation: "Interprétation",
    addToFavorites: "Ajouter aux favoris",
    removeFromFavorites: "Retirer des favoris",
    recent: "Récents",
    favorites: "Favoris",
    popular: "Populaires",
    history: "Historique",
    noHistory: "Aucun calcul récent",
    noFavorites: "Aucun favori",
    calculationSaved: "Calcul sauvegardé",
    calculationError: "Erreur lors du calcul",
    emptyStateTitle: "Commencez à calculer",
    emptyStateDesc: "Sélectionnez un score clinique pour démarrer vos calculs",
    browseCalculators: "Parcourir les calculateurs",
    loadFavoritesError: "Erreur lors du chargement des favoris",
    calculationParamError: "Erreur dans le calcul. Vérifiez les paramètres.",
    fillAllFields: "Veuillez remplir tous les paramètres avant de calculer.",
    loginRequired: "Vous devez être connecté pour ajouter des favoris",
    addedToFavorites: "Ajouté aux favoris",
    removedFromFavorites: "Retiré des favoris",
    updateFavoritesError: "Erreur lors de la mise à jour des favoris",
    calculatorSaved: "Calculateur sauvegardé !",
    saveError: "Erreur lors de la sauvegarde",
    updateError: "Erreur lors de la mise à jour",
    calculatorDeleted: "Calculateur supprimé",
    deleteError: "Erreur lors de la suppression",
    saveCalculation: "Sauvegarder ce calcul",
    parametersUsed: "Paramètres utilisés",
    backToIndex: "← Index",
    backToForm: "Modifier",
    availableScores: "scores disponibles",
    yes: "Oui",
    no: "Non",
    otherParams: "autres",
    
    specialties: {
      anesthesia: "Anesthésie",
      burns: "Brûlés",
      cardiology: "Cardiologie",
      surgery: "Chirurgie Viscérale",
      dermatology: "Dermatologie",
      endocrinology: "Endocrinologie",
      gastroenterology: "Gastro-entérologie",
      gynecology: "Gynécologie-Obstétrique",
      hematology: "Hématologie",
      hepatology: "Hépatologie",
      infectiology: "Infectiologie",
      nephrology: "Néphrologie",
      neurology: "Neurologie",
      orthopedics: "Orthopédie",
      pediatrics: "Pédiatrie",
      pneumology: "Pneumologie",
      emergency: "Urgences",
      urology: "Urologie"
    },

    parameters: {
      age: "Âge (années)",
      gender: "Sexe",
      weight: "Poids (kg)",
      height: "Taille (cm)",
      male: "Homme",
      female: "Femme",
      yes: "Oui",
      no: "Non",
      
      // Anesthésie
      activity: "Activité motrice",
      respiration: "Respiration",
      circulation: "Circulation",
      consciousness: "Conscience",
      color: "Coloration",
      non_smoker: "Non fumeur",
      ponv_history: "NVPO antérieur",
      opioids: "Opioïdes postop",
      minor_surgery: "Chirurgie mineure",
      major_surgery: "Chirurgie majeure",
      bmi: "IMC",
      pregnancy: "Grossesse",
      malignancy: "Néoplasie",
      confined_bed: "Alitement",
      immobilizing_cast: "Plâtre immobilisant",
      high_risk_surgery: "Chirurgie à haut risque",
      ischemic_heart: "Cardiopathie ischémique",
      heart_failure: "Insuffisance cardiaque",
      cerebrovascular: "AVC/AIT",
      diabetes: "Diabète insulino-requérant",
      renal_failure: "Insuffisance rénale (créat >177)",
      
      // Cardiologie
      active_cancer: "Cancer actif",
      paralysis_paresis: "Paralysie/parésie MI",
      bedridden: "Alité >3j ou chirurgie <4sem",
      localized_tenderness: "Douleur mollet/trajet veineux",
      entire_leg_swollen: "Jambe entière gonflée",
      calf_swelling: "Mollet +3cm vs controlatéral",
      pitting_edema: "Œdème godet MI symptomatique",
      collateral_veins: "Veines superficielles collatérales",
      alternative_diagnosis: "Diagnostic alternatif probable",
      chf: "Insuffisance cardiaque",
      hypertension: "Hypertension artérielle",
      stroke: "AVC/AIT/embolie antérieur",
      vascular: "Maladie vasculaire",
      ankle_pressure: "Pression systolique cheville",
      brachial_pressure: "Pression systolique brachiale",
      hematocrit: "Hématocrite (%)",
      creatinine: "Créatininémie (µmol/L)",
      heart_rate: "Fréquence cardiaque (bpm)",
      systolic_bp: "PAS (mmHg)",
      total_cholesterol: "Cholestérol total (mg/dL)",
      hdl: "HDL cholestérol (mg/dL)",
      smoker: "Tabagisme actif",
      abnormal_renal: "Fonction rénale anormale",
      abnormal_liver: "Fonction hépatique anormale",
      bleeding: "Hémorragie antérieure",
      labile_inr: "INR labile",
      elderly: "Âge >65 ans",
      drugs: "Médicaments (AINS, antiagrégants)",
      alcohol: "Alcoolisme (>8 verres/sem)",
      
      // Chirurgie
      blood_loss: "Pertes sanguines (mL)",
      blood_pressure: "PA moyenne (mmHg)",
      organ_failure: "Défaillance d'organe",
      duration: "Durée évolution (heures)",
      origin: "Origine péritonite",
      peritoneal_fluid: "Liquide péritonéal",
      extent: "Extension",
      nausea: "Nausées/vomissements",
      anorexia: "Anorexie",
      migration: "Migration douleur",
      tenderness: "Défense FID",
      cough_pain: "Douleur à la toux",
      elevated_temp: "Température >38°C",
      leukocytosis: "Leucocytes >10000",
      neutrophilia: "Polynucléaires >75%",
      
      // Dermatologie
      sensory: "Perception sensorielle",
      moisture: "Humidité",
      mobility: "Mobilité",
      nutrition: "Nutrition",
      friction: "Frottement/cisaillement",
      physical_condition: "État physique",
      mental_condition: "État mental",
      incontinence: "Incontinence"
    }
  },
  en: {
    title: "Medical Calculator",
    subtitle: "Standardized clinical scores and medical formulas",
    search: "Search for a score, formula...",
    filterBySpecialty: "Filter by specialty",
    allSpecialties: "All specialties",
    loading: "Loading calculators...",
    noCalculators: "No calculators available",
    noCalculatorsDesc: "Use search to find a medical score",
    calculate: "Calculate",
    reset: "Reset",
    result: "Result",
    interpretation: "Interpretation",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    recent: "Recent",
    favorites: "Favorites",
    popular: "Popular",
    history: "History",
    noHistory: "No recent calculations",
    noFavorites: "No favorites",
    calculationSaved: "Calculation saved",
    calculationError: "Calculation error",
    emptyStateTitle: "Start calculating",
    emptyStateDesc: "Select a clinical score to start your calculations",
    browseCalculators: "Browse calculators",
    loadFavoritesError: "Error loading favorites",
    calculationParamError: "Calculation error. Check the parameters.",
    fillAllFields: "Please fill all parameters before calculating.",
    loginRequired: "You must be logged in to add favorites",
    addedToFavorites: "Added to favorites",
    removedFromFavorites: "Removed from favorites",
    updateFavoritesError: "Error updating favorites",
    calculatorSaved: "Calculator saved!",
    saveError: "Error saving",
    updateError: "Error updating",
    calculatorDeleted: "Calculator deleted",
    deleteError: "Error deleting",
    saveCalculation: "Save this calculation",
    parametersUsed: "Parameters used",
    backToIndex: "← Index",
    backToForm: "Edit",
    availableScores: "available scores",
    yes: "Yes",
    no: "No",
    otherParams: "others",
    
    specialties: {
      anesthesia: "Anesthesiology",
      burns: "Burns",
      cardiology: "Cardiology",
      surgery: "Surgery",
      dermatology: "Dermatology",
      endocrinology: "Endocrinology",
      gastroenterology: "Gastroenterology",
      gynecology: "Gynecology-Obstetrics",
      hematology: "Hematology",
      hepatology: "Hepatology",
      infectiology: "Infectious Diseases",
      nephrology: "Nephrology",
      neurology: "Neurology",
      orthopedics: "Orthopedics",
      pediatrics: "Pediatrics",
      pneumology: "Pulmonology",
      emergency: "Emergency",
      urology: "Urology"
    },

    parameters: {
      age: "Age (years)",
      gender: "Gender",
      weight: "Weight (kg)",
      height: "Height (cm)",
      male: "Male",
      female: "Female",
      yes: "Yes",
      no: "No",
      activity: "Motor activity",
      respiration: "Respiration",
      circulation: "Circulation",
      consciousness: "Consciousness",
      color: "Color"
    }
  },
  es: {
    title: "Calculadora Médica",
    subtitle: "Puntuaciones clínicas y fórmulas médicas estandarizadas",
    search: "Buscar puntuación, fórmula...",
    filterBySpecialty: "Filtrar por especialidad",
    allSpecialties: "Todas las especialidades",
    loading: "Cargando calculadoras...",
    noCalculators: "No hay calculadoras disponibles",
    noCalculatorsDesc: "Use la búsqueda para encontrar una puntuación médica",
    calculate: "Calcular",
    reset: "Reiniciar",
    result: "Resultado",
    interpretation: "Interpretación",
    addToFavorites: "Agregar a favoritos",
    removeFromFavorites: "Quitar de favoritos",
    recent: "Recientes",
    favorites: "Favoritos",
    popular: "Populares",
    history: "Historial",
    noHistory: "Sin cálculos recientes",
    noFavorites: "Sin favoritos",
    calculationSaved: "Cálculo guardado",
    calculationError: "Error en el cálculo",
    emptyStateTitle: "Comience a calcular",
    emptyStateDesc: "Seleccione una puntuación clínica para comenzar",
    browseCalculators: "Explorar calculadoras",
    loadFavoritesError: "Error al cargar favoritos",
    calculationParamError: "Error en el cálculo. Verifique los parámetros.",
    fillAllFields: "Por favor complete todos los parámetros antes de calcular.",
    loginRequired: "Debe iniciar sesión para agregar favoritos",
    addedToFavorites: "Agregado a favoritos",
    removedFromFavorites: "Eliminado de favoritos",
    updateFavoritesError: "Error al actualizar favoritos",
    calculatorSaved: "¡Calculadora guardada!",
    saveError: "Error al guardar",
    updateError: "Error al actualizar",
    calculatorDeleted: "Calculadora eliminada",
    deleteError: "Error al eliminar",
    saveCalculation: "Guardar este cálculo",
    parametersUsed: "Parámetros utilizados",
    backToIndex: "← Índice",
    backToForm: "Modificar",
    availableScores: "puntuaciones disponibles",
    yes: "Sí",
    no: "No",
    otherParams: "otros",
    
    specialties: {
      anesthesia: "Anestesiología",
      burns: "Quemaduras",
      cardiology: "Cardiología",
      surgery: "Cirugía",
      dermatology: "Dermatología",
      endocrinology: "Endocrinología",
      gastroenterology: "Gastroenterología",
      gynecology: "Ginecología-Obstetricia",
      hematology: "Hematología",
      hepatology: "Hepatología",
      infectiology: "Enfermedades Infecciosas",
      nephrology: "Nefrología",
      neurology: "Neurología",
      orthopedics: "Ortopedia",
      pediatrics: "Pediatría",
      pneumology: "Neumología",
      emergency: "Urgencias",
      urology: "Urología"
    },

    parameters: {
      age: "Edad (años)",
      gender: "Sexo",
      weight: "Peso (kg)",
      height: "Altura (cm)",
      male: "Hombre",
      female: "Mujer",
      yes: "Sí",
      no: "No",
      activity: "Actividad motora",
      respiration: "Respiración",
      circulation: "Circulación",
      consciousness: "Conciencia",
      color: "Color"
    }
  }
};